import { Directive, Input, ElementRef, Renderer2, Inject } from '@angular/core';

import { GasDynamicComponentsService } from '@cikrf/gas-utils/services';

import { GasBrowserEventsService } from '../../../utils/gas-browser-event/gas-browser-events.service';
import { GasPositioning } from '../../../utils/gas-positioning/gas-positioning.namespace';
import { GasPositioningService } from '../../../utils/gas-positioning/gas-positioning.service';
import { GAS_POSITIONING_CONFIG } from '../../gas-dynamic-positioning-popup/gas-dynamic-positioning-popup.constant';
import { GasDynamicPositioningPopupDirective } from '../../gas-dynamic-positioning-popup/gas-dynamic-positioning-popup.directive';
import { GasPositioningPopup } from '../../gas-dynamic-positioning-popup/gas-dynamic-positioning-popup.namespace';
import { GasPopoverComponent } from './gas-popover.component';

@Directive({
  selector: '[gasPopover]',
})
export class GasPopoverDirective extends GasDynamicPositioningPopupDirective<
  void,
  GasPopoverComponent
> {
  @Input('gasPopover')
  public set setup(value: Omit<GasPositioningPopup.Config<GasPopoverComponent>, 'component'>)  {
    this.config = {
      ...this.injectionConfig,
      ...{
        preferablePositions: [
          GasPositioning.Direction.Top,
          GasPositioning.Direction.TopRight,
          GasPositioning.Direction.TopLeft,
        ],
      },
      ...value,
      component: GasPopoverComponent,
    };
  }

  /** Без модификаторов доступа, ибо они указаны в расширяемом классе */
  constructor(
    el: ElementRef,
    gasDynamicComponentsService: GasDynamicComponentsService,
    gasPositioningService: GasPositioningService,
    gasBrowserEventsService: GasBrowserEventsService,
    render: Renderer2,
    @Inject(GAS_POSITIONING_CONFIG)
    private injectionConfig: GasPositioningPopup.Config<GasPopoverComponent>,
  ) {
    super(
      el,
      gasDynamicComponentsService,
      gasPositioningService,
      gasBrowserEventsService,
      render,
    );
  }
}
